import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Html5Qrcode } from 'html5-qrcode';
import { Box, TextField, Card } from '@mui/material';
import { Typography, IconButton, Button } from '@tucar/pit-stop';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const fullScreenWrapper = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100dvh',
  zIndex: 10,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  borderSizing: 'border-box',
  backgroundColor: '#424242',
  color: '#fff',
};

const QRScanner = ({ onClose, onConfirm, errorInScan }) => {
  const [manualCode, setManualCode] = useState('');
  const [cameraError, setCameraError] = useState(false);

  useEffect(() => {
    const qrCodeRegionId = 'qr-reader';
    const html5QrCode = new Html5Qrcode(qrCodeRegionId);
    let isScannerClosed = false;
    let isScannerStarted = false;

    const qrCodeSuccessCallback = (decodedText) => {
      if (isScannerClosed) return;
      setManualCode(decodedText);
    };

    const config = { fps: 10, qrbox: { width: 200, height: 200 } };

    html5QrCode
      .start({ facingMode: 'environment' }, config, qrCodeSuccessCallback)
      .then(() => {
        isScannerStarted = true;
      })
      .catch(() => {
        if (isScannerClosed) return;
        setCameraError(true);
      });

    return () => {
      isScannerClosed = true;
      if (isScannerStarted) {
        html5QrCode.stop().catch((err) => {
          errorInScan(
            `Error al cerrar el scanner, si no inicia la camara reinicie la app, error: ${err.message}`,
          );
        });
      }
    };
  }, []);

  const handleConfirmClick = () => {
    onConfirm(manualCode);
  };

  return (
    <Box sx={fullScreenWrapper}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: '26px',
          borderSizing: 'border-box',
        }}
      >
        <IconButton
          onClick={onClose}
          iconProps={{ name: 'leftArrowSpecial' }}
          style={{ alignSelf: 'flex-start', zIndex: 6 }}
        />

        <Typography variant="h1" fontSize={20} weight="semi-bold" style={{ zIndex: 6 }}>
          Escanea el código QR del hub de carga
        </Typography>

        {/* Área del Escáner */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'fixed',
            zIndex: 5,
            inset: 0,
          }}
        >
          {cameraError ? (
            <Box sx={{ textAlign: 'center' }}>
              <ReportProblemIcon sx={{ fontSize: 40 }} />
              <Typography variant="p">No se pudo acceder a la cámara.</Typography>
              <Typography variant="p">Por favor, ingresa el código manualmente. </Typography>
            </Box>
          ) : (
            <Box id="qr-reader" sx={{ width: '100%', maxHeight: '500px' }} />
          )}
        </Box>

        {/* Área de Ingreso Manual */}
        <Card
          style={{
            padding: '20px',
            height: 'auto',
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            margin: '20px 20px',
            boxSizing: 'border-box',
            zIndex: 6,
          }}
        >
          <Typography variant="h2" fontSize={16} color="#5A6571">
            Ingresar código manual
          </Typography>
          <TextField
            fullWidth
            variant="standard"
            value={manualCode}
            onChange={(e) => setManualCode(e.target.value)}
          />
          <Box
            sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}
          >
            <Typography variant="p" fontSize={14} color="#5A6571">
              Lo puedes encontrar en...
            </Typography>
            <Button variant="contained" disabled={!manualCode} onClick={handleConfirmClick}>
              Continuar
            </Button>
          </Box>
        </Card>
      </Box>
    </Box>
  );
};

QRScanner.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  errorInScan: PropTypes.func.isRequired,
};

export default QRScanner;
